<template>
    <rkm-area
        title="Paciente"
        type="fieldset"
    >
        <rkm-row>
            <rkm-col>
                <h4>
                    {{ data.form.paciente.nome }} <strong v-if="data.form.paciente.nomeSocial">({{ data.form.paciente.nomeSocial }})</strong>
                </h4>
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="3">
                <strong>Prontuário:</strong> {{ data.form.paciente.prontuario }}
            </rkm-col>

            <rkm-col cols="6">
                <strong>Sexo:</strong> {{ data.form.paciente.sexo }}
            </rkm-col>

            <rkm-col cols="3">
                <strong>CPF:</strong> {{ data.form.paciente.cpf }}
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="3">
                <strong>Data de nascimento:</strong> {{ data.form.paciente.dataNascimento }}
            </rkm-col>

            <rkm-col cols="6">
                <strong>Nome da mãe:</strong> <component :is="data.form.paciente.nomeMae ? 'span' : 'em'">{{ data.form.paciente.nomeMae || 'Desconhecido' }}</component>
            </rkm-col>

            <rkm-col cols="3">
                <strong>CNS:</strong> {{ data.form.paciente.cns }}
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="3">
                <strong>Idade:</strong> {{ data.form.paciente.idade }}
            </rkm-col>

            <rkm-col cols="6">
                <strong>Unidade de referência:</strong> {{ data.form.paciente.unidadeReferencia }}
            </rkm-col>

            <rkm-col cols="3">
                <strong>RG:</strong> {{ data.form.paciente.rg }}
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="3">
                <strong>Telefone:</strong> {{ data.form.paciente.telefone }}
            </rkm-col>
        </rkm-row>

        <hr>

        <rkm-form ref="Form">
            <rkm-row>
                <rkm-col cols="3">
                    <rkm-form-input
                        :disabled="!data.additionals.permiteEdicao"
                        :validations="validations.prontuarioUnidade"
                        label="Prontuário da unidade"
                        uppercase
                        v-model="data.model.prontuarioUnidade"
                    />
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-input
                        :disabled="!data.additionals.permiteEdicao"
                        :validations="validations.peso"
                        @input="handlePesoInput"
                        label="Peso"
                        v-mask="mask.peso"
                        v-model="data.model.peso"
                    >
                        <template slot="append">
                            <rkm-button
                                :disabled="!data.additionals.permiteEdicao"
                                :color="data.model.pesoUnidadeMedidaId === enums.unidadeMedida.QUILOGRAMAS ? 'secondary' : 'light'"
                                @click="setUnidadeMedida('peso', enums.unidadeMedida.QUILOGRAMAS)"
                            >
                                {{ getUnidadeMedida(enums.unidadeMedida.QUILOGRAMAS).sigla }}
                            </rkm-button>

                            <rkm-button
                                :disabled="!data.additionals.permiteEdicao"
                                :color="data.model.pesoUnidadeMedidaId === enums.unidadeMedida.GRAMAS ? 'secondary' : 'light'"
                                @click="setUnidadeMedida('peso', enums.unidadeMedida.GRAMAS)"
                            >
                                {{ getUnidadeMedida(enums.unidadeMedida.GRAMAS).sigla }}
                            </rkm-button>
                        </template>
                    </rkm-form-input>
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-input
                        :disabled="!data.additionals.permiteEdicao"
                        :validations="validations.altura"
                        @input="handleAlturaInput"
                        label="Altura"
                        v-mask="mask.altura"
                        v-model="data.model.altura"
                    >
                        <template slot="append">
                            <rkm-button
                                :disabled="!data.additionals.permiteEdicao"
                                :color="data.model.alturaUnidadeMedidaId === enums.unidadeMedida.METROS ? 'secondary' : 'light'"
                                @click="setUnidadeMedida('altura', enums.unidadeMedida.METROS)"
                            >
                                {{ getUnidadeMedida(enums.unidadeMedida.METROS).sigla }}
                            </rkm-button>

                            <rkm-button
                                :disabled="!data.additionals.permiteEdicao"
                                :color="data.model.alturaUnidadeMedidaId === enums.unidadeMedida.CENTIMETROS ? 'secondary' : 'light'"
                                @click="setUnidadeMedida('altura', enums.unidadeMedida.CENTIMETROS)"
                            >
                                {{ getUnidadeMedida(enums.unidadeMedida.CENTIMETROS).sigla }}
                            </rkm-button>
                        </template>
                    </rkm-form-input>
                </rkm-col>
            </rkm-row>
        </rkm-form>
    </rkm-area>
</template>

<script>
// Others.
import unidadeMedida from '@/enums/cadastro/unidadeMedida'

export default {
    computed: {
        validations() {

            return {
                prontuarioUnidade: { max: 10 },
                peso: {},
                altura: {},
            }
        }
    },
    data: () => ({
        enums: { unidadeMedida },
        mask: {
            altura: '###',
            peso: '######',
        },
    }),
    methods: {
        validate() {

            return this.$refs.Form.validate()
        },
        handlePesoInput(item) {

            const length = item.replace('.', '').length

            if (this.data.model.pesoUnidadeMedidaId === this.enums.unidadeMedida.QUILOGRAMAS) {

                if (length <= 3) {

                    this.mask.peso = '#.##'
                }
                else if (length <= 4) {

                    this.mask.peso = '##.##'
                }
                else {

                    this.mask.peso = '###.##'
                }
            }
            else {

                this.mask.peso = '######'
            }
        },
        handleAlturaInput() {

            if (this.data.model.alturaUnidadeMedidaId === this.enums.unidadeMedida.METROS) {

                this.mask.altura = '#.##'
            }
            else {

                this.mask.altura = '###'
            }
        },
        getUnidadeMedida(id) {

            return this.data.form.unidadesMedida.find(unidade => unidade.id === id)
        },
        setUnidadeMedida(key, destinoId) {

            if (this.data.model[`${key}UnidadeMedidaId`] == destinoId) return false

            this.$nextTick(() => {

                this.data.model[`${key}UnidadeMedidaId`] = destinoId
            })
        },
    },
    props: {
        data: { type: Object, required: true },
    },
    watch: {
        'data.model.pesoUnidadeMedidaId'() {

            this.$nextTick(() => {

                this.data.model.peso = ''
            })
        },
        'data.model.alturaUnidadeMedidaId'() {

            this.$nextTick(() => {

                this.data.model.altura = ''
            })
        },
    },
}
</script>